import { useEventsApi } from 'services/api/hooks/useEventsApi.hook';
import useSWR from 'swr';

export const useEventFeedbackData = (eventId: string, isOpen: boolean) => {
  const eventsApi = useEventsApi();

  // Fetch event
  const { data: event } = useSWR(
    eventId && isOpen ? `/events/${eventId}` : null,
    async () => {
      const result = await eventsApi.getEvent(eventId);
      if (!result.success) return null;
      return result.value;
    },
  );

  // Fetch feedback status
  const { data: feedbackStatus } = useSWR(
    eventId && isOpen ? `/events/${eventId}/feedback/status` : null,
    async () => {
      const result = await eventsApi.getEventFeedbackStatus(eventId);
      if (!result.success) return { hasSubmitted: false };
      return result.value;
    },
  );

  // Fetch existing feedback if submitted
  const { data: existingFeedback } = useSWR(
    eventId && isOpen && feedbackStatus?.hasSubmitted
      ? `/events/${eventId}/feedback`
      : null,
    async () => {
      const result = await eventsApi.getEventFeedback(eventId);
      if (!result.success) return null;
      return result.value;
    },
  );

  // Fetch feedback questions
  const { data: questionsData } = useSWR(
    isOpen ? 'feedback-questions' : null,
    async () => {
      const result = await eventsApi.getFeedbackQuestions();
      if (!result.success) return { questions: [] };
      return result.value;
    },
  );

  return {
    event,
    feedbackStatus,
    existingFeedback,
    questions: questionsData?.questions || [],
  };
};

